/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getProfilePhotoBulkInternal} from '../api'

 export const useQueryGetProfilePhotoBulkInternal = createReactQueryHook('getProfilePhotoBulkInternal', getProfilePhotoBulkInternal)
